export interface InvalidUserIdMatchWithAllMatches {
  invalidUserId: string;
  extractedDisplayName: string;
  matchCount: number;
  recommendationCount: number;
  auditCount: number;
  totalCount: number;
  possibleMatches: AzureUserMatch[];
  selectedAzureUserId?: string; // Für UI-State, wird vom Frontend gesetzt
}

export interface AzureUserMatch {
  id: string;
  displayName: string;
  mail: string;
}

export interface ApplySingleMatchPayload {
  invalidUserId: string;
  azureUserId: string;
}

export enum NameMatchingStrategy {
  Normalized = 0,
  Exact = 1,
  FirstAndLastName = 2
}

export interface GraphMatchOptions {
  nameMatchingStrategy?: NameMatchingStrategy;
  emailDomainFilter?: string;
}
